import React from "react";

class Page2 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 2) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      Values can be defined as what motivates you to do well and
                      what you consider to be important in life. They give a
                      sense of purpose to the work which you are doing.
                      <br />
                      <br />
                      When a job matches your values you're usually satisfied
                      and content; when it doesn’t, it can feel wrong and become
                      a source of unhappiness.
                      <br />
                      <br />
                      On the next page we are presenting you with some of the
                      main factors individuals find important in their careers.
                      Take your time with this activity and really think about
                      what’s important to you. On completion you will come away
                      with a list of your 5 essential values.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page2;
